import React from 'react';
import Link from 'next/link';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import { V2Route } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './challengeButton.module.scss';
const cx = classnames.bind(styles);

interface ChallengeButtonProps {
  positionDetail: PositionDetailVO;
}

const ChallengeButton = ({ positionDetail }: ChallengeButtonProps) => {
  const {
    additionalInfo: { challenge },
  } = positionDetail;

  if (!challenge || challenge.challengeStatus === 'READY') return null;

  return (
    <Link href={V2Route.getChallengePage(challenge.challengeSn)} legacyBehavior>
      <a className={cx('challengeButton')} role="button">
        {challenge.challengeName}
      </a>
    </Link>
  );
};

export default ChallengeButton;
